import React from 'react';
import { Image as KonvaImage, Circle } from 'react-konva';
import useImage from 'use-image';

const FloorPlanImage = ({
  src,
  canvasWidth,
  canvasHeight,
  rotation = 0,
  opacity = 1,
  scale = 1,
  showCenterPoint = false,
  centerPoint = null,
}) => {
  const [anonImage, anonStatus] = useImage(src, 'anonymous');
  // Fallback: some floor plans are served without CORS headers, which makes the
  // crossOrigin="anonymous" load fail silently (needed for canvas export). If that
  // happens, re-load without crossOrigin so the image at least displays; layer/PDF
  // export for this image may then hit a tainted-canvas error until the server sends
  // Access-Control-Allow-Origin for the image URL.
  const [plainImage] = useImage(anonStatus === 'failed' ? src : null);
  const image = anonImage || plainImage;
  if (!image) return null;

  const padding = { left: 75, right: 75, top: 105, bottom: 105 };
  const availableWidth  = canvasWidth  - (padding.left + padding.right);
  const availableHeight = canvasHeight - (padding.top  + padding.bottom);

  const imageAspect  = image.width / image.height;
  const canvasAspect = availableWidth / availableHeight;

  let width, height, x, y;
  if (imageAspect > canvasAspect) {
    width  = availableWidth;
    height = width / imageAspect;
    x = padding.left;
    y = padding.top + (availableHeight - height) / 2;
  } else {
    height = availableHeight;
    width  = height * imageAspect;
    x = padding.left + (availableWidth - width) / 2;
    y = padding.top;
  }

  const centerX = x + width / 2;
  const centerY = y + height / 2;

  return (
    <>
      <KonvaImage
        image={image}
        x={centerX}
        y={centerY}
        width={width}
        height={height}
        offsetX={width / 2}
        offsetY={height / 2}
        rotation={rotation}
        opacity={opacity}
        scaleX={scale}
        scaleY={scale}
        listening={false}
      />
      {showCenterPoint && centerPoint && (
        <Circle
          x={centerPoint.x}
          y={centerPoint.y}
          radius={5}
          fill="#FF0000"
          stroke="#FFFFFF"
          strokeWidth={2}
          listening={false}
        />
      )}
    </>
  );
};

export default FloorPlanImage;
